import { FragmentProvider } from "core/components/FragmentProvider";
import { Subscription } from "../entities/Subscription";
import { SubscriptionComponentConfig } from "./SubscriptionComponentConfig";
import * as subscriptionMeta from "./subscriptionMeta";


export interface ISubscriptionComponentProps {
	config?: SubscriptionComponentConfig;
	subscription: Subscription;
}

export const MetaProvider = FragmentProvider.forFragments<ISubscriptionComponentProps>("subscription:meta", subscriptionMeta);
export const metaInput = FragmentProvider.getInput<ISubscriptionComponentProps>(subscriptionMeta);




// WEBPACK FOOTER //
// ./src/panels/subscriptions/component/SubscriptionComponent.tsx